// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2bEIw","container":"styles_container__3x-ej","title":"styles_title__3UWjV","wrapper":"styles_wrapper__3Tau9","answer":"styles_answer__8Ngh9"};